export const SIS_DECIMALS = 18
export const VESIS_DECIMALS = 18
